import { useState } from 'react'
import { ToteEngagementModeEnum } from '@mote/api'

/**
 * @typedef {{assistiveCarousel: string[], affirmativeCarousel: string[]}} CarouselMap
 */

/**
 * @typedef {Object} UseCarousel
 * @property {(rotatedCarouselMap: CarouselMap) => void} rotate
 * @property {(mode: ToteEngagementMode) => string} first
 */

/**
 * @param {CarouselMap} initialCarouselMap
 * @return {UseCarousel}
 */
export function useCarousel(initialCarouselMap) {
  const [carousels, setCarousels] = useState(initialCarouselMap)
  return {
    first: mode => {
      if (mode === ToteEngagementModeEnum.ASSISTIVE) {
        return carousels.assistiveCarousel[0]
      }
      return carousels.affirmativeCarousel[0]
    },
    rotate: rotatedCarouselMap => setCarousels(rotatedCarouselMap)
  }
}
